export const commonColorMap = [
    '#FFFFFF',
    '#000000',
    '#DD3612',
    '#ED7D31',
    '#FFBF00',
    '#71AD47',
    '#5B9BD5',
    '#44536A',
    '#3F5BB6',
];
export const defaultColorMap = [
    '#F2F2F2',
    '#808080',
    '#FDE0DB',
    '#FBE5D6',
    '#FFF1CC',
    '#E1EFD9',
    '#DEEAF7',
    '#D6DCE5',
    '#D9DEF0',
    '#D9D9D9',
    '#595959',
    '#FBC1B6',
    '#F8CBAD',
    '#FFE699',
    '#C5E0B4',
    '#BDD7EE',
    '#ADB9C9',
    '#B2BDE1',
    '#BFBFBF',
    '#404040',
    '#F9A192',
    '#F4B183',
    '#FFD966',
    '#A9D18E',
    '#9DC3E6',
    '#8497B0',
    '#8C9DD3',
    '#A6A6A6',
    '#262626',
    '#DD3611',
    '#C55A11',
    '#BF9001',
    '#548235',
    '#2F74B6',
    '#323F50',
    '#3F5BB5',
    '#7F7F7F',
    '#0D0D0D',
    '#840B0B',
    '#843C0B',
    '#7F6001',
    '#385723',
    '#204E79',
    '#222A35',
    '#203D79',
];
